import { MembershipsCreatorApiClient } from '@fourthwall/services/dist/MembershipsCreatorApiClient'
import { createMutationHook } from '@fourthwall/utils'

export const useUpdatePollPostMutation = createMutationHook(
  MembershipsCreatorApiClient.updatePollPost,
  {
    mutationKey: ['updatePollPost'],
  },
)
